import React from 'react';
import { Result } from 'antd';
import 'jquery/src/jquery';
import 'bootstrap/dist/js/bootstrap.min.js';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '../../css/style.css';
import CurrentNode from './CurrentNode';
import ConnectedNodes from './ConnectedNodes';
import NodeControl from './NodeControl';

const ControlPanel = ({ showPanel }) => (
  <div id="controlPanel" className={showPanel ? '' : 'hide'}>
    <ul className="nav nav-tabs">
      <li className="active">
        <a data-toggle="tab" href="#currentNode">
          Cá nhân
        </a>
      </li>
      <li>
        <a data-toggle="tab" href="#connectedNodes">
          Gia đình
        </a>
      </li>
      <li>
        <a data-toggle="tab" href="#nodeControl">
          Xem
        </a>
      </li>
    </ul>

    <div className="tab-content">
      <CurrentNode />
      <ConnectedNodes />
      <NodeControl />
    </div>
    {/* <img id="checkMark" src={CheckMark} style={{ display: 'none' }} /> */}
    <div id="checkMark" style={{ display: 'none' }}>
      <Result status="success" />
    </div>
  </div>
);

export default ControlPanel;
